export const BRANDS = [
  "KFC",
  "Pret A Manger",
  "Kings Gyms",
  "M&S Food",
  "Rafael House"
] as const;

export type Brand = typeof BRANDS[number] | "";
